import { ActionButton } from '@adobe/react-spectrum';
import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { useNavigate } from 'react-router-dom';
import Play from '@spectrum-icons/workflow/Play';

export function BreadCrumbPlaytestButton(props) {
    const navigate = useNavigate();

    return (
        <ActionButton
            UNSAFE_className="playtest-action-btn"
            isDisabled={props.isDisabled}
            aria-label="Playtest"
            onPress={() => {
                // logEvent(getAnalytics(), 'playtest_click', { deckId: props.deckId });
                navigate(`/details/deck/${props.deckId}/playtest`);
            }}
        >
            <span className="bcBtnLabel">Playtest</span>
            <Play />
        </ActionButton>
    );
}
